import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PublicLanding } from './features/auth/PublicLanding';
import { NotFound } from './features/misc/NotFound';
import { useTheme } from './lib/useTheme';

const CourseShell = lazy(() =>
  import('./features/course/CourseShell').then((m) => ({ default: m.CourseShell })),
);
const CoursesIndex = lazy(() =>
  import('./features/course/CoursesIndex').then((m) => ({ default: m.CoursesIndex })),
);

export function App() {
  const { theme } = useTheme();
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <Routes>
      <Route path="/" element={<PublicLanding />} />
      <Route
        path="/courses"
        element={
          <Suspense fallback={null}>
            <CoursesIndex />
          </Suspense>
        }
      />
      <Route
        path="/courses/:lessonId"
        element={
          <Suspense fallback={null}>
            <CourseShell />
          </Suspense>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
